import { createEnv } from "@t3-oss/env-core";
import { z } from "zod";

// On the server, values come from process.env.
// On the client, values come from window.__ENV__ injected by the Nitro server plugin.
const runtimeEnv =
  typeof window !== "undefined"
    ? ((window as unknown as { __ENV__?: Record<string, string> }).__ENV__ ??
      {})
    : (process.env as Record<string, string | undefined>);

export const env = createEnv({
  /**
   * The prefix that client-side variables must have. This is enforced both at
   * a type-level and at runtime.
   */
  clientPrefix: "VITE_",

  client: {
    VITE_APP_TITLE: z.string().min(1).default("Reliquo"),
    VITE_OIDC_AUTHORITY: z.string().url(),
    VITE_OIDC_CLIENT_ID: z.string().min(1),
    VITE_OIDC_REDIRECT_URI: z.string().url(),
    VITE_API_BASE_URL: z.string().url(),
    VITE_RELIQUO_ENV: z.enum(["prod", "dev"]).default("prod"),
  },

  /**
   * What object holds the environment variables at runtime.
   * We use a unified runtime object so values are not baked at build time.
   */
  runtimeEnv,

  /**
   * Skip validation during build-time (when VITE_OIDC_AUTHORITY is not set).
   */
  skipValidation:
    !!process.env.SKIP_ENV_VALIDATION ||
    (typeof window === "undefined" && !process.env.VITE_OIDC_AUTHORITY),

  /**
   * By default, this library will feed the environment variables directly to
   * the Zod validator.
   */
  emptyStringAsUndefined: true,
});
